var map = {
	"./guarda-val.jpg": 273,
	"./kulm.jpg": 274,
	"./rocksresort.jpg": 275,
	"./schweizerhof.jpg": 276,
	"./spitzhorn.jpg": 277,
	"./the-chedi.jpg": 278,
	"./tschuggen.jpg": 279,
	"./waldhaus.jpg": 280,
	"./zurbriggen-1.jpg": 281
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 272;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/images/hotels eager ^\.\/.*\.jpg$
// module id = 272
// module chunks = 1